<template>
    <div id="offers">
        <div class="header-offers">
            <span class="title">Top Offers</span>
        </div>
        <div class="offers-list">
            <div class="list-box">
                <p class="title">Lorem ipsum dolor sit amet conset esadipscing elitr</p>
                <p class="description">Lorem ipsum dolor sit amet, conse te tursa dipsc ing elitr, sed diam nonu my eirmo dte por invidu nt ut lab ore et dolore mag na.</p>
            </div>
            <div class="list-box">
                <div class="list-img"></div>
                <p class="title">Lorem ipsum dolor sit amet conset esadipscing elitr</p>
                <p class="description">Lorem ipsum dolor sit amet, conse te tursa dipsc ing elitr, sed diam nonu my eirmo dte por invidu nt ut lab ore et dolore mag na.</p>
            </div>
            <div class="list-box">
                <div class="list-img"></div>
                <p class="title">Lorem ipsum dolor sit amet conset esadipscing elitr</p>
                <p class="description">Lorem ipsum dolor sit amet, conse te tursa dipsc ing elitr, sed diam nonu my eirmo dte por invidu nt ut lab ore et dolore mag na.</p>
            </div>
            <div class="list-box">
                <div class="list-img"></div>
                <p class="title">Lorem ipsum dolor sit amet conset esadipscing elitr</p>
                <p class="description">Lorem ipsum dolor sit amet, conse te tursa dipsc ing elitr, sed diam nonu my eirmo dte por invidu nt ut lab ore et dolore mag na.</p>
            </div>
            <div class="load-more text-center">
                <button type="button" class="btn btn-load-more">
                    Load more
                </button>
            </div>
            <div class="ig">
                <div class="title">Traveler Snapshots</div>
                <ImagesBoard :columns="2" :tag="tag" :bgColor="'#401616'" :loadMore="true" :btnWhite="true"/>
            </div>
        </div>
        <Footerdiv />
    </div>
</template>

<script>
import ImagesBoard from "@/components/ImagesBoard";
import Footerdiv from "@/components/Footer";
import Snapshots from "@/components/Snapshots";

export default {
    name : 'offers',
    components: {
        Footerdiv,
        Snapshots,
        ImagesBoard
    },
    data() {
        return {
            tag : {
                type: Number
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #offers {
        padding-top: 52px;
        .header-offers {
            position: relative;
            width: 100%;
            height: 300px;
            background-color: #CBCBCB;

            .title {
                position: absolute;
                left: 10px;
                bottom: 5px;
                color: #E13036;
                font-size: 44px;
                font-weight: bold;
            }
        }

        .offers-list {
            background-color: #401616;
            padding: 20px 15px;

            .list-box {
                margin-bottom: 60px;

                .list-img {
                    height: 210px;
                    width: 100%;
                    border-radius: 10px;
                    background-color: #D9D9D9;
                }

                .title {
                    color: #E13036;
                    font-size: 20px;
                    font-weight: bold;
                }

                .description {
                    color: #FFF;
                    font-size: 13px;
                }
            }

            .load-more {
                .btn-load-more {
                    border: 2px #FFF solid;
                    color: #FFF;
                    font-size: 16px;
                    font-weight: 500;
                }
            }

            .ig {
                margin: 75px -15px 0;

                .title {
                    color: #FFF;
                    font-size: 20px;
                    font-weight: bold;
                    padding:0 15px 25px;
                }
            }
            
        }
    }
</style>


